import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './validatedSelectModalInput.module.scss'
import { HiOutlineChevronDown } from 'react-icons/hi'
import ValidatedInput from '../ValidatedInput'
import Modal from '../Modal'
import { AiOutlineClose } from 'react-icons/ai'

const Option = ({ data, onClick }) => {
  const { label } = data
  return (
    <div onClick={onClick} className={styles.option}>
      {label}
    </div>
  )
}

const ValidatedSelectModalInput = React.forwardRef(
  (
    {
      message,
      rules,
      name,
      header,
      error,
      showErrorAsNeutral,
      successIcon,
      errorIcon,
      onSelect,
      options,
      placeholder,
      defaultSelected,
      ...restProps
    },
    ref
  ) => {
    const [visible, setVisible] = useState(false)
    const [value, setValue] = useState(defaultSelected || '')

    const handleSelect = (option) => () => {
      setVisible(false)
      setValue(option.value)
      onSelect({ target: { name, value: option.value } })
    }

    const vRules = rules || []
    return (
      <div className={styles.container}>
        <div className={styles.selector} onClick={() => setVisible(true)}>
          <ValidatedInput
            rules={vRules}
            type='text'
            ref={ref}
            name={name}
            value={value}
            placeholder={placeholder}
            header={!error && header}
            error={error}
            readOnly
            showErrorAsNeutral={showErrorAsNeutral}
            {...restProps}
          />
          <div className={styles.chevron}>
            <span>
              <HiOutlineChevronDown />
            </span>
          </div>
        </div>
        <Modal isOpen={visible} classNames={[styles.modal]}>
          <div className={styles.closeIconContainer}>
            <AiOutlineClose size='16px' onClick={() => setVisible(false)} />
          </div>
          <h3 className={styles.title}>{placeholder}</h3>
          <section className={styles.options}>
            {options.map((e) => (
              <Option key={e.id} onClick={handleSelect(e)} data={e} />
            ))}
          </section>
        </Modal>
      </div>
    )
  }
)

ValidatedSelectModalInput.propTypes = {
  placeholder: PropTypes.string,
  onSelect: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
      label: PropTypes.string
    })
  )
}

ValidatedSelectModalInput.defaultProps = {
  options: [],
  placeholder: '',
  onSelect: () => 1,
  name: ''
}

export default ValidatedSelectModalInput
